const GALLERY_ITEMS = [
  {
    before: "https://public.readdy.ai/ai/img_res/1ddcfd3d12c6845e489ba07040e48f9a.jpg",
    after: "https://readdy.ai/api/search-image?query=clean%20bright%20open%20residential%20backyard%20northern%20virginia%20green%20lawn%20clear%20sky%20neat%20property%20after%20professional%20tree%20removal%20service%20completed&width=560&height=420&seq=gal2026b&orientation=landscape",
    label: "Hazardous Oak Removal",
    loc: "Fredericksburg, VA",
    tag: "Tree Removal",
    tagColor: "#e8632a",
  },
  {
    before: "https://readdy.ai/api/search-image?query=overgrown%20tree%20canopy%20blocking%20light%20branches%20hanging%20over%20roof%20gutters%20driveway%20untrimmed%20messy%20residential%20property%20before%20professional%20trimming&width=560&height=420&seq=gal2026c&orientation=landscape",
    after: "https://readdy.ai/api/search-image?query=beautifully%20shaped%20well%20pruned%20mature%20shade%20tree%20clean%20open%20canopy%20residential%20yard%20bright%20sunny%20northern%20virginia%20after%20professional%20arborist%20trimming&width=560&height=420&seq=gal2026d&orientation=landscape",
    label: "Crown Thinning & Shaping",
    loc: "Stafford County, VA",
    tag: "Tree Trimming",
    tagColor: "#1a3a2e",
  },
  {
    before: "https://readdy.ai/api/search-image?query=ugly%20large%20old%20tree%20stump%20middle%20residential%20lawn%20grass%20overgrown%20roots%20eyesore%20tripping%20hazard%20before%20stump%20grinding%20northern%20virginia&width=560&height=420&seq=gal2026e&orientation=landscape",
    after: "https://readdy.ai/api/search-image?query=smooth%20level%20green%20lawn%20clean%20mulch%20filled%20area%20after%20professional%20stump%20grinding%20removed%20residential%20backyard%20northern%20virginia%20neat%20finished&width=560&height=420&seq=gal2026f&orientation=landscape",
    label: "Stump Grinding",
    loc: "Spotsylvania, VA",
    tag: "Stump Grinding",
    tagColor: "#e8632a",
  },
  {
    before: "https://readdy.ai/api/search-image?query=storm%20damage%20fallen%20tree%20on%20fence%20roof%20residential%20property%20northern%20virginia%20after%20storm%20debris%20branches%20everywhere%20emergency%20cleanup%20needed&width=560&height=420&seq=gal2026g&orientation=landscape",
    after: "https://readdy.ai/api/search-image?query=clean%20repaired%20residential%20property%20fence%20line%20all%20debris%20cleared%20after%20storm%20damage%20tree%20removal%20cleanup%20northern%20virginia%20neat%20finished&width=560&height=420&seq=gal2026h&orientation=landscape",
    label: "Storm Damage Emergency",
    loc: "King George, VA",
    tag: "Emergency",
    tagColor: "#c0392b",
  },
];

export default function GallerySection() {
  return (
    <section className="py-24 bg-[#f8f6f3]">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <span className="text-[#e8632a] font-bold text-sm uppercase tracking-[3px] block mb-3">Real Results</span>
            <h2 className="text-4xl lg:text-5xl font-black text-[#1e1e1e] leading-tight">
              Before &amp; After Gallery
            </h2>
            <div className="w-14 h-1.5 bg-[#e8632a] mt-4 rounded-full"></div>
          </div>
          <div className="flex items-center gap-4">
            <p className="text-gray-500 text-sm hidden md:block">Real jobs, real Northern Virginia properties.</p>
            <a
              href="/gallery"
              className="flex items-center gap-2 px-5 py-2.5 border-2 border-[#1a3a2e] text-[#1a3a2e] font-bold rounded-xl text-sm uppercase tracking-wide hover:bg-[#1a3a2e] hover:text-white transition-all cursor-pointer whitespace-nowrap"
            >
              Full Gallery <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>

        {/* Masonry-style grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {GALLERY_ITEMS.map((item, i) => (
            <div
              key={item.label}
              className="bg-white rounded-3xl overflow-hidden group"
              style={{ marginTop: i % 2 === 1 ? "24px" : "0" }}
            >
              {/* Tag row */}
              <div className="px-5 pt-5 pb-3 flex items-center justify-between">
                <span
                  className="text-white text-xs font-black uppercase tracking-wider px-3 py-1.5 rounded-full"
                  style={{ backgroundColor: item.tagColor }}
                >
                  {item.tag}
                </span>
                <div className="flex items-center gap-1.5 text-gray-400 text-xs font-medium">
                  <i className="ri-map-pin-line"></i>
                  {item.loc}
                </div>
              </div>

              {/* Before/After split */}
              <div className="grid grid-cols-2 gap-2 px-5 pb-3">
                <div className="relative overflow-hidden rounded-2xl h-48">
                  <img
                    src={item.before}
                    alt={`Before — ${item.label}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-[#1e1e1e]/20"></div>
                  <div className="absolute bottom-3 left-3 bg-[#1e1e1e] text-white text-[10px] font-black uppercase tracking-widest px-2.5 py-1 rounded-lg">
                    Before
                  </div>
                </div>
                <div className="relative overflow-hidden rounded-2xl h-48">
                  <img
                    src={item.after}
                    alt={`After — ${item.label}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute bottom-3 left-3 bg-[#1a3a2e] text-white text-[10px] font-black uppercase tracking-widest px-2.5 py-1 rounded-lg">
                    After
                  </div>
                </div>
              </div>

              <div className="px-5 pb-5">
                <p className="font-black text-[#1e1e1e] text-sm">{item.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
